import $ from "jquery";

$(document).ready(function(){

    if ((document.getElementsByClassName('c-filter').length) && (!document.querySelector(".c-filter").classList.contains("c-filter--dynamic"))) {

        function getActiveName() {
            let activeFilter = $(".c-filter .c-filter__filters .active").text();
            let activeFilterNoSpaces = activeFilter.replace(/\s+/g, '');
            $('.c-filter__active-filter').text(activeFilterNoSpaces);
        }

        getActiveName();

        $(".c-filter__filters .c-filter__filters-item").on('click', function(e) {
            $('.c-filter .active').removeClass('active');
            $(this).addClass('active');
            getActiveName();
        });

        $(".c-filter__trigger").on('click', function() {
            if($(this).hasClass('c-filter__trigger--closed')) {
                $(this).removeClass('c-filter__trigger--closed').addClass('c-filter__trigger--opened');
            } else {
                $(this).removeClass('c-filter__trigger--opened').addClass('c-filter__trigger--closed');
            }
            $(".c-filter__filters").slideToggle();
        });


        // Filter Effect
        // Check if there is a c-filter on the page first
        if (document.getElementsByClassName('c-filter').length){
            var cFilter = document.querySelector('[data-component="filter"]');
            var cFilterItems = cFilter.querySelectorAll('[data-filter-items] .c-card, [data-filter-items] .has-filter');
            cFilter.addEventListener('click', applyFilter, false);
        }

        function applyFilter() {
            let animateInClass = 'fadeIn';
            let animateOutClass = 'fadeOut';
            let animateOutPosition = 'c-filter-item--hidden';

            if(event.target.hasAttribute('data-filter-value')) {
                let thisFilterValue = event.srcElement.getAttribute("data-filter-value");
                let thisFilterValueNoSpaces = thisFilterValue.replace(/\s+/g, '');

                if (thisFilterValueNoSpaces) {
                    for ( var i=0; i < cFilterItems.length; i++ ) {
                        var thisItem = cFilterItems[i];
                        var thisItemFilters = thisItem.getAttribute('data-filter-list').split(' ');

                        if (thisItemFilters.indexOf(thisFilterValueNoSpaces) > -1) {
                            thisItem.classList.remove('animated');
                            thisItem.classList.remove(animateOutClass);
                            thisItem.classList.remove(animateOutPosition);
                            thisItem.classList.add('animated');
                            thisItem.classList.add(animateInClass);
                        }
                        else {
                            thisItem.classList.add('animated');
                            thisItem.classList.add(animateOutClass);
                            thisItem.classList.add(animateOutPosition);
                        }

                    }
                }
                else {
                    for ( var i=0; i < cFilterItems.length; i++ ) {
                        cFilterItems[i].classList.remove('animated');
                        cFilterItems[i].classList.remove(animateOutClass);
                        cFilterItems[i].classList.remove(animateOutPosition);
                    }
                }
            }
        }

    }
});
